import { Box, Divider, Stack, useTheme } from "@mui/material";
import React from "react";

import FilterCard from "components/pages/dashboard/surgery_types_procedures/filter/cards/FilterCard";
import SingleSelectField from "components/pages/dashboard/surgery_types_procedures/filter/cards/SingleSelectField";

const SingleSelectFilterCard = ({ filters }) => {
  const theme = useTheme();
  const [primaryFilter] = filters;

  const metaChip = primaryFilter.meta && (
    <Box
      component="span"
      sx={{
        px: 1.25,
        py: 0.5,
        borderRadius: "4px",
        fontSize: "0.6875rem",
        fontWeight: 600,
        letterSpacing: "0.04em",
        textTransform: "uppercase",
        whiteSpace: "nowrap",
        bgcolor: theme.palette.grey[200],
        color: theme.palette.text.secondary,
      }}
    >
      {primaryFilter.meta}
    </Box>
  );

  return (
    <FilterCard
      title={primaryFilter.cardTitle ?? primaryFilter.label}
      description={primaryFilter.description}
      badge={metaChip}
    >
      <Stack spacing={2.5} divider={<Divider />}>
        {filters.map((filter) => (
          <SingleSelectField key={filter.field} filter={filter} />
        ))}
      </Stack>
    </FilterCard>
  );
};

export default SingleSelectFilterCard;
